module.exports = __webpack_public_path__ + "img/avatar-ana-oarga.91380f57.jpg";